module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "chapter1"
    }
  }, [_c('h1', {
    staticClass: "left"
  }, [_c('a', {
    attrs: {
      "href": "#/004toc#january1"
    }
  }, [_vm._v("January 1")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Your indecisiveness will prove to be your biggest shortcoming. When faced with a tough decision, such as whether to confront a horde of hungry zombies or retreat to a dark, windowless basement, remember that your first instinct is generally your best.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("Beware of:")]), _vm._v(" Clowns with sharpened teeth")]), _vm._v(" "), _c('div', {
    staticClass: "image",
    attrs: {
      "id": "image4"
    }
  }, [_c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "image 4",
      "src": "images/StarRule.jpg"
    }
  })])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9da18290","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/006chapter1.vue
// module id = 72
// module chunks = 0